export const Approved = () => (
  <svg fill="none" height="121" viewBox="0 0 121 121" width="121" xmlns="http://www.w3.org/2000/svg">
    <g id="Approval">
      <g id="approval--work-approval">
        <g id="documents">
          <path
            d="M55.7607 53.0386L49.5195 45.184L31.5441 40.8634L3.37415 57.16L42.3747 106.265L80.4903 84.1618L72.8793 74.5828"
            id="Vector"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M39.5056 50.9567L29.662 41.9405L31.5442 40.8521L39.5056 50.9567Z" fill="#1072BA" id="Vector_2" />
          <path
            d="M39.5056 50.9567L29.662 41.9405L31.5442 40.8521L39.5056 50.9567Z"
            id="Vector_3"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M56.7771 76.2688C52.1301 73.591 49.4169 69.0592 49.4715 64.837C46.1759 64.1014 42.7252 64.5934 39.7665 66.2206C33.7557 69.7006 32.7465 77.4028 37.5207 83.4022C42.2949 89.4124 51.0387 91.4542 57.0495 87.9622C58.7576 87.0074 60.1573 85.5845 61.0841 83.861C62.0109 82.1376 62.4261 80.1852 62.2809 78.2338C60.3413 77.9218 58.4757 77.2558 56.7771 76.2688Z"
            fill="#2ED3AE"
            id="Vector_4"
          />
          <path
            d="M56.7771 76.2688C52.1301 73.591 49.4169 69.0592 49.4715 64.837C46.1759 64.1014 42.7252 64.5934 39.7665 66.2206C33.7557 69.7006 32.7465 77.4028 37.5207 83.4022C42.2949 89.4124 51.0387 91.4542 57.0495 87.9622C58.7576 87.0074 60.1573 85.5845 61.0841 83.861C62.0109 82.1376 62.4261 80.1852 62.2809 78.2338C60.3413 77.9218 58.4757 77.2558 56.7771 76.2688Z"
            id="Vector_5"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.5082 45.1613L39.5056 50.9567L31.5442 40.8521"
            id="Vector_6"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.214 60.97L31.9642 51.274"
            id="Vector_7"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.4418 67.5707L46.5028 52.4867"
            id="Vector_8"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.6053 79.9775L51.9915 83.0165L51.5836 71.4833"
            id="Vector_9"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g id="hand">
          <path
            d="M53.2162 56.0824L50.6422 60.5056C47.716 65.563 50.4622 72.6256 56.7772 76.2688C62.434 79.5436 69.9772 79.3402 73.5274 73.6606L76.0546 69.277"
            id="Vector_10"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.5908 51.9695C55.4534 52.8884 53.7646 54.6131 52.891 56.7695C50.7214 62.1023 54.1912 68.3399 59.5672 71.4371C64.3528 74.2007 70.6018 74.4677 74.4916 71.0513C75.0855 70.5301 75.6098 69.9346 76.0516 69.2795"
            id="Vector_11"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.8994 34.297L89.0866 39.151C88.0438 40.9654 85.8322 41.9176 83.3596 41.9176C76.1236 41.9176 70.2022 34.4644 72.8926 29.806L75.6934 24.952C74.4232 27.1636 75.1606 29.8852 76.567 31.9384C80.6584 37.9132 89.3794 38.6344 91.8994 34.297Z"
            id="Vector_12"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.993 53.44C98.4915 60.6826 91.5687 68.9008 85.9455 73.3996C83.9712 73.1007 82.043 72.5519 80.2071 71.7664C76.6425 69.9788 73.4577 67.5179 70.8285 64.5196L74.8653 57.5794C74.2158 56.3999 73.6255 55.1888 73.0965 53.9506C72.5477 54.2179 71.9297 54.3088 71.3271 54.211C72.2571 57.2278 70.9533 58.498 68.9343 58.237C69.8079 61.0384 67.8117 62.197 65.0787 61.1518C65.4639 63.3628 62.2929 63.6946 59.7483 61.5598C57.7251 59.8618 54.5061 55.0648 56.6883 52.9198C56.9635 52.6529 57.3174 52.4818 57.6975 52.432C57.2895 50.878 57.3975 49.3084 58.9113 48.3946C59.1601 48.2407 59.4382 48.1404 59.7279 48.1C59.2941 45.6706 60.5727 43.9888 62.4495 43.4386C62.4675 42.8224 62.6451 42.2214 62.9649 41.6944C63.2847 41.1674 63.7359 40.7324 64.2741 40.432C63.3177 38.9598 62.5732 37.3603 62.0625 35.6806C61.4811 33.2854 63.3225 31.8652 65.7711 33.7528C66.5775 34.375 67.6419 35.272 68.9121 36.304C69.2637 36.1 72.5865 34.4668 72.5865 34.4668C72.7167 34.8724 72.8799 35.2672 73.0743 35.6464C73.0743 35.6464 72.4743 36.6898 71.5095 38.3344C74.6055 40.648 78.4269 43.12 82.4985 44.458L83.9613 41.938C85.6845 41.8947 87.3233 41.1831 88.5315 39.9538C92.3475 43.2988 90.5037 41.5114 101.993 53.44Z"
            id="Vector_13"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.7333 36.2818C84.1641 39.1168 75.4077 34.0216 75.0585 27.8326C74.8599 24.3178 77.6985 22.1854 81.4185 22.1854C85.8075 22.1854 90.4479 25.1824 92.0223 29.2054C93.1467 32.074 92.4837 34.8814 89.7333 36.2818Z"
            fill="#1072BA"
            id="Vector_14"
          />
          <path
            d="M89.7333 36.2818C84.1641 39.1168 75.4077 34.0216 75.0585 27.8326C74.8599 24.3178 77.6985 22.1854 81.4185 22.1854C85.8075 22.1854 90.4479 25.1824 92.0223 29.2054C93.1467 32.074 92.4837 34.8814 89.7333 36.2818Z"
            id="Vector_15"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M80.2186 71.764C79.402 73.8172 79.2658 75.304 79.9576 75.8806C80.8876 76.6522 83.1328 75.631 85.9576 73.3972C83.9934 73.0523 82.0701 72.505 80.2186 71.764Z"
            fill="#1072BA"
            id="Vector_16"
          />
          <path
            d="M80.2186 71.764C79.402 73.8172 79.2658 75.304 79.9576 75.8806C80.8876 76.6522 83.1328 75.631 85.9576 73.3972C83.9934 73.0523 82.0701 72.505 80.2186 71.764Z"
            id="Vector_17"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.3068 49.6072L101.993 53.44C104.502 47.962 102.665 46.6768 98.3068 49.6072Z"
            fill="#1072BA"
            id="Vector_18"
          />
          <path
            d="M98.3068 49.6072L101.993 53.44C104.502 47.962 102.665 46.6768 98.3068 49.6072Z"
            id="Vector_19"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.045 69.2717C75.8062 69.6449 75.5368 69.9977 75.2398 70.3265L70.8286 64.5197C72.3843 66.2937 74.1341 67.8876 76.045 69.2717Z"
            fill="#1072BA"
            id="Vector_20"
          />
          <path
            d="M76.045 69.2717C75.8062 69.6449 75.5368 69.9977 75.2398 70.3265L70.8286 64.5197C72.3843 66.2937 74.1341 67.8876 76.045 69.2717Z"
            id="Vector_21"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M109.999 61.1404C110.003 61.3426 109.967 61.5435 109.892 61.7314C109.817 61.9193 109.706 62.0905 109.564 62.2349C109.423 62.3792 109.254 62.4939 109.067 62.5722C108.881 62.6504 108.681 62.6907 108.479 62.6907C108.276 62.6907 108.076 62.6503 107.89 62.5719C107.703 62.4936 107.535 62.3789 107.393 62.2344C107.251 62.09 107.14 61.9188 107.066 61.7309C106.991 61.5429 106.955 61.342 106.959 61.1398C106.967 60.7419 107.13 60.3629 107.415 60.0844C107.699 59.8058 108.081 59.6498 108.479 59.6499C108.877 59.65 109.259 59.8061 109.543 60.0848C109.828 60.3635 109.991 60.7425 109.999 61.1404Z"
            fill="#1072BA"
            id="Vector_22"
          />
          <path
            d="M109.999 61.1404C110.003 61.3426 109.967 61.5435 109.892 61.7314C109.817 61.9193 109.706 62.0905 109.564 62.2349C109.423 62.3792 109.254 62.4939 109.067 62.5722C108.881 62.6504 108.681 62.6907 108.479 62.6907C108.276 62.6907 108.076 62.6503 107.89 62.5719C107.703 62.4936 107.535 62.3789 107.393 62.2344C107.251 62.09 107.14 61.9188 107.066 61.7309C106.991 61.5429 106.955 61.342 106.959 61.1398C106.967 60.7419 107.13 60.3629 107.415 60.0844C107.699 59.8058 108.081 59.6498 108.479 59.6499C108.877 59.65 109.259 59.8061 109.543 60.0848C109.828 60.3635 109.991 60.7425 109.999 61.1404Z"
            id="Vector_23"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.9722 41.9068C81.7517 41.9741 79.5564 41.4207 77.6331 40.3088C75.7099 39.197 74.1349 37.5707 73.0852 35.6128C73.0852 35.6128 72.4852 36.6556 71.5204 38.3008C74.6164 40.6138 78.4378 43.0858 82.5094 44.4244L83.9722 41.9068Z"
            fill="#2ED3AE"
            id="Vector_24"
          />
          <path
            d="M83.9722 41.9068C81.7517 41.9741 79.5564 41.4207 77.6331 40.3088C75.7099 39.197 74.1349 37.5707 73.0852 35.6128C73.0852 35.6128 72.4852 36.6556 71.5204 38.3008C74.6164 40.6138 78.4378 43.0858 82.5094 44.4244L83.9722 41.9068Z"
            id="Vector_25"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.8546 57.5795C74.2046 56.4002 73.6141 55.189 73.0852 53.9507C72.5364 54.218 71.9184 54.3089 71.3158 54.2111C72.2458 57.2279 70.942 58.4981 68.923 58.2371C69.7966 61.0385 67.8004 62.1971 65.0674 61.1519C65.4532 63.3629 62.2816 63.6947 59.737 61.5599C59.617 61.4567 59.4766 61.3199 59.317 61.1747C59.9781 63.0045 61.2903 64.5264 63.0028 65.4497C65.2696 66.7541 69.097 67.3775 70.3288 65.3249L74.8546 57.5795Z"
            fill="#2ED3AE"
            id="Vector_26"
          />
          <path
            d="M74.8546 57.5795C74.2046 56.4002 73.6141 55.189 73.0852 53.9507C72.5364 54.218 71.9184 54.3089 71.3158 54.2111C72.2458 57.2279 70.942 58.4981 68.923 58.2371C69.7966 61.0385 67.8004 62.1971 65.0674 61.1519C65.4532 63.3629 62.2816 63.6947 59.737 61.5599C59.617 61.4567 59.4766 61.3199 59.317 61.1747C59.9781 63.0045 61.2903 64.5264 63.0028 65.4497C65.2696 66.7541 69.097 67.3775 70.3288 65.3249L74.8546 57.5795Z"
            id="Vector_27"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.8546 57.5795C76.249 60.0743 78.064 62.4899 80.1502 63.3743"
            id="Vector_28"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.5204 38.3002C68.8486 36.3046 67.5892 35.1148 65.782 33.73C63.337 31.8562 61.498 33.2644 62.0734 35.6578C63.0556 39.7408 69.1804 47.5804 71.872 50.7412C71.872 50.7412 72.3028 52.102 73.0966 53.9506"
            id="Vector_29"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.9205 45.364C85.4148 45.2232 83.9306 44.9074 82.4979 44.4232"
            id="Vector_30"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.7034 47.9056C60.1906 51.1948 63.5116 54.871 64.4548 55.7764C65.6606 57.034 67.2248 57.8893 68.9344 58.2256"
            id="Vector_31"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M73.0942 53.9507C71.7898 54.6197 69.5908 54.2105 67.0612 51.8753C65.893 50.7953 62.3434 46.6553 62.4568 43.4153"
            id="Vector_32"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.7072 52.4194C58.3534 54.8464 60.337 57.4444 61.1434 58.3162C62.2271 59.5433 63.5718 60.5122 65.0788 61.1518"
            id="Vector_33"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M102.684 48.3142L116.781 60.4828"
            id="Vector_34"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.969 75.8944L93.226 87.4846"
            id="Vector_35"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g id="elements">
          <path
            d="M80.6038 97.2041C80.8934 97.2039 81.1766 97.2895 81.4175 97.4503C81.6585 97.611 81.8463 97.8396 81.9573 98.1072C82.0682 98.3747 82.0974 98.6691 82.041 98.9532C81.9846 99.2373 81.8452 99.4983 81.6404 99.7031C81.4356 99.9079 81.1747 100.047 80.8907 100.104C80.6066 100.16 80.3122 100.131 80.0446 100.021C79.777 99.9097 79.5484 99.722 79.3875 99.4811C79.2267 99.2403 79.1409 98.9571 79.141 98.6675C79.1419 98.2798 79.2963 97.9082 79.5704 97.634C79.8446 97.3598 80.2161 97.2052 80.6038 97.2041Z"
            id="Vector_36"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
          <path
            d="M48.4191 15.0635L48.4077 24.9521"
            id="Vector_37"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
          <path
            d="M53.3637 20.0189L43.4631 20.0081"
            id="Vector_38"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
          <path
            d="M105.123 31.3601L106.132 33.3899L108.366 33.7187L106.744 35.2949L107.13 37.5293L105.123 36.4745L103.127 37.5293L103.501 35.2949L101.879 33.7187L104.124 33.3899L105.123 31.3601Z"
            id="Vector_39"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.12"
          />
        </g>
      </g>
    </g>
  </svg>
);
